import { createSelector } from '@reduxjs/toolkit';
import { getRecommendedPropertyAvailability } from './getRecommendedPropertyAvailability';
import { getPropertyId } from 'store/property/propertySelectors';
import reduce from 'lodash/reduce';

export const getGa4RecommendedProperties = createSelector(getRecommendedPropertyAvailability, getPropertyId, (results) => {
  const firstThreeProperties = results.slice(0, 3);

  const properties = reduce(
    firstThreeProperties,
    (accum, item) => {
      const mappedItem = {
        property: {
          ...item?.property,
          hasOffer: item?.offer?.promotion?.name ? true : false,
          promotionName: item?.offer?.promotion?.name || null,
          hasDepositPayableOffer: item?.property?.hasDepositPayableOffer,
          recommend: true,
          rebook: false,
        },
        roomType: item.roomType,
        offer: {
          charges: {
            total: item?.offer?.charges?.total,
            totalCash: item?.offer?.charges?.totalCash,
          },
        },
      };
      return [...accum, mappedItem];
    },
    [],
  );

  return properties;
});
